import fetchEventsAPI from './fetchEvents';
import fetchEventAPI from './fetchEvent';

const api = {
  fetchEventsAPI,
  fetchEventAPI
};
export default api;
